<template>
    <div class="study-wrap">
        <div class="progress-box">
            <div class="progress-bar" v-if="showWord" :style="{width:studyData.progress+'%'}"></div>
        </div>
        <div class="left-title">
            <div>
                <img src="../../../../assets/img/grammarTest/book.png" alt="">
                <p>语法复习中</p>
            </div>
            <!--倒计时区域-->
            <div v-if="showWord&&isCountdown==1" class="countDown">
                {{content}}
            </div>
        </div>
        <div class="content-box">
            <transition name="el-fade-in-linear" mode="out-in">
                <!--强制复习的提示语-->
                <div class="hint-text" v-if="isHint" key="save">
                    <div v-if="dataSource.reviewNum==0">
                        <div class="hint-box">
                            <div>目前暂时没有语法需要复习~~~</div>
                        </div>
                        <div style="margin-top:30px;">
                            <el-button type="success" @click="$emit('quit')">退出</el-button>
                        </div>
                    </div>
                    <div v-else>
                        <div class="hint-box">
                            <div>目前你有超过{{dataSource.reviewNum}}个语法没有复习了</div>
                            <div>【系统强制复习中】</div>
                            <div style="margin-top:30px;">
                                <el-button type="success" @click="beginStudy()">开始回忆</el-button>
                            </div>
                        </div>
                        <div class="hint-box-tips" key="edit">
                            注：根据设置，每次最多复习50个语法。
                        </div>
                    </div>
                </div>
                <!--强制复习-智能复习-->
                <div class="exercise-box" v-if="showWord">
                    <div class="word">
                        <div class="statement-text">
                            <transition name="el-fade-in-linear" mode="out-in">
                                <div v-show="showTopic">
                                    {{grammarData.name}}<img class="volume" src="@/assets/img/grammarTest/volume.png" @click="playAudio">
                                </div>
                            </transition>
                            <audio id="eventAudio" :src="grammarData.voice" autoplay></audio>
                        </div>
                    </div>
                    <!--查看翻译提示框-->
                    <div class="tooltip">
                        <transition name="el-fade-in-linear" mode="out-in">
                            <div class="symbol" v-if="hiddenAnswer" key="blank">
                                ?
                            </div>
                            <div class="answer td-f1" v-if="hiddenAnswer==false" @click="hiddenAnswer==false"
                                    key="noblank">
                                {{grammarData.meaning}}
                            </div>
                        </transition>
                    </div>
                    <!--弹窗下方按钮-->
                    <transition name="el-fade-in-linear" mode="out-in">
                        <div class="control-box" v-if="hiddenAnswer" key="1">
                            <!-- 下一题按钮隐藏 -->
                            <!--语法刚出现时默认的控制按钮-->
                            <div v-for="(item,index) in faceBtnInitial" :key="index">
                                <div @click="btnOperation(item.type)">
                                    <img :src="item.imgSrc" alt="">
                                </div>
                            </div>
                        </div>

                        <!--点击了笑脸时-->
                        <div class="control-box" key="2" v-if="isSmiling">
                            <div v-for="(item,index) in smilingFace" :key="index">
                                <div @click="smilingOperation(item.type)">
                                    <img :src="item.imgSrc" alt="">
                                </div>
                            </div>
                        </div>
                        <!--点击了哭脸时-->
                        <div class="control-box" key="3" v-if="isCrying">
                            <div @click="faceOrCrying(0)">
                                <img src="../../../../assets/img/grammarTest/circle_arrows.png" alt="">
                            </div>
                        </div>

                    </transition>

                </div>
            </transition>
        </div>

        <div class="el-message-box__content">
            <div class="el-message-box__container">
            </div>
        </div>
        <div class="el-message-box__btns" key="edit" v-if="showWord">
            记忆时间【{{timeNum}}】当前生词【{{studyData.err_num||0}}】识别次数【{{studyData.num||1}}】
        </div>
    </div>
</template>

<script>
    import {clickFace, getGrammar} from "@/api/grammar";
    import Lockr from 'lockr'
    import {mapState, mapGetters, mapMutations} from 'vuex';

    export default {
        name: "voiceDiscern",
        props: {
            reviewNum: {
                default: 0
            },//需要语法复习的个数
            dataSource: {
                default: {
                    studentId: 0,
                    reviewNum: 0,
                }
            },
        },
        computed: {},
        data() {
            return {
                isCountdown: 1,
                faceBtnInitial: [
                    //{imgSrc: require('../../../../assets/img/grammarTest/circle_arrows.png'), type: '1'}
                    {imgSrc: require('../../../../assets/img/grammarTest/smiling.png'), type: '2'},
                    {imgSrc: require('../../../../assets/img/grammarTest/crying.png'), type: '3'},
                    {imgSrc: require('../../../../assets/img/grammarTest/headset2.png'), type: '4'},
                ],
                smilingFace: [
                    {imgSrc: require('../../../../assets/img/grammarTest/correct.png'), type: '1'},
                    {imgSrc: require('../../../../assets/img/grammarTest/error.png'), type: '2'},
                    {imgSrc: require('../../../../assets/img/grammarTest/headset2.png'), type: '3'},
                    // {imgSrc: require('../../../../assets/img/grammarTest/circle_arrows.png'), type: '4'},
                ],
                showTopic: true,//是否显示语句
                isHint: true,//是否显示强制复习提示语
                showWord: false,//显示语法学习的内容
                hiddenAnswer: true,//是否显示答案
                isSmiling: false,//笑脸
                isCrying: false,//苦脸
                totalTime: 15,//倒计时初始时间
                content: '',
                clock: '',//倒计时
                timeVal: {
                    hour: 0,
                    minutes: 0,
                    seconds: 0
                },
                timeNum: '',//记忆时间
                secondNum: 0,//只记录秒格式
                studyData: '',//点击笑脸哭脸返回的数据
                studyTime: '',//记录间隔时间
                grammarData: {},
                isCreated: false,
                topicStatus: 1,//防抖
            }
        },
        methods: {
            ...mapMutations(['CHANGE_STUDY_TYPE']),
            //触发发音
            playAudio() {
                let buttonAudio = document.getElementById('eventAudio');
                buttonAudio && buttonAudio.play()
            },
            //语法刚出现时的按钮控制
            btnOperation(type) {
                if (type == 1) {
                    //直接进入下一题，相当于直接点击了笑脸
                    this.getAnswer('3',)
                } else if (type == 2) {
                    //笑脸
                    this.getAnswer('1')
                } else if (type == 3) {
                    //哭脸
                    this.getAnswer('0')
                } else if (type == 4) {
                    this.playAudio()
                }
            },

            //笑脸时的按钮控制
            smilingOperation(type) {
                if (type == 1) {
                    //笑脸
                    this.faceOrCrying(1)
                } else if (type == 2) {
                    //哭脸
                    this.faceOrCrying(0)
                } else if (type == 3) {
                    this.playAudio()
                } else if (type == 4) {
                    this.nextTopic()
                }
            },

            // 查看答案
            getAnswer(type) {
                if (type === '1') {//笑脸
                    this.hiddenAnswer = false
                    this.isCrying = false
                    this.isSmiling = true
                    // this.clickFace(1, this.studyData.num, this.studyData.state)
                    this.countDown('stop', this.grammarData.time)
                } else if (type === '0') {//哭脸
                    this.hiddenAnswer = false
                    this.isSmiling = false
                    this.isCrying = true
                    // this.clickFace(0, this.studyData.num, this.studyData.state)
                    this.countDown('stop', this.grammarData.time)
                } else if (type == 3) {
                    this.clickFace(1, this.studyData.num, this.studyData.state,)
                    this.countDown('', this.grammarData.time)
                }
            },

            //记录点击笑脸/哭脸
            clickFace(isPass, num = 1, state = 1) {
                if (this.topicStatus == 2) {
                    this.topicStatus = 1//1开始保存笑脸哭脸状态 2获取到了下一个
                    let params = {
                        token: Lockr.get('token'),
                        student_id: this.dataSource.studentId,//学员Id
                        num: num,//学习总次数
                        state: state,//类型
                        grammar_id: this.grammarData.id,//语法Id
                        count: this.dataSource.reviewNum,//本组语法总数
                        study_time: this.studyTime,//学习时间
                        is_pass: isPass,//是否通过
                    }
                    clickFace(params).then(res => {
                        this.studyData = res.data
                        if (res.data.is_complete == 0) {
                            this.getGrammarData(this.studyData.num, this.studyData.state)
                        } else if (res.data.is_complete == 1) {
                            //开启拼写阶段
                            let data = {
                                title: '强制复习',
                                type: 'compel/spell',
                                dataSource: this.dataSource,
                                isStudyEnd: true,
                                closeBtn: false,
                            }
                            //开启逆向记忆阶段
                            // let data = {
                            //     title: '强制复习',
                            //     type: 'compel/reverseMemory',
                            //     dataSource: this.dataSource,
                            //     isStudyEnd: true,
                            //     closeBtn: false,
                            // }
                            this.CHANGE_STUDY_TYPE(data)
                        }
                    })
                }
            },
            //查看翻译之后 点击了正确或者错误
            faceOrCrying(type) {
                this.hiddenAnswer = true
                this.isSmiling = false
                this.isCrying = false

                // this.getAnswer(type)
                this.clickFace(type, this.studyData.num, this.studyData.state)
                this.countDown('', this.grammarData.time)
            },
            // 下一个语法
            nextTopic() {
                this.hiddenAnswer = true
                //获取下一个语法
                this.getGrammarData(this.studyData.num, this.studyData.state)
                this.countDown('', this.grammarData.time)
            },
            // 获取强制复习语法
            getGrammarData(num = 1, state = 1) {
                let dataSource = this.dataSource
                let params = {
                    token: Lockr.get('token'),
                    student_id: dataSource.studentId,
                    count: dataSource.reviewNum,
                    num: num,
                    state: state,
                }
                getGrammar(params).then(res => {
                    this.topicStatus = 2
                    this.grammarData = res.data.grammar
                    this.recordIntervalTime('reset')
                    this.playAudio()
                }).catch((err) => {
                })
            },
            //开始复习
            beginStudy() {
                this.isHint = false;
                this.showWord = true
                this.countDown('', this.grammarData.time)
                this.timeKeep()
                this.recordIntervalTime()
            },
            //倒计时
            countDown(stop, entTime) {
                //每切换一题倒计时重置一遍
                window.clearInterval(this.clock)
                if (stop) return //查看答案时 计时器不执行
                this.totalTime = entTime
                this.content = this.totalTime
                this.clock = window.setInterval(() => {
                    this.totalTime--
                    this.content = this.totalTime
                    if (this.totalTime <= 0) {
                        window.clearInterval(this.clock)
                        this.getAnswer('0')
                        this.totalTime = entTime
                    }
                }, 1000)
            },

            // 记录间隔时间
            recordIntervalTime(reset) {
                let timer = setInterval(() => {
                    this.studyTime += 1
                }, 1000)
                if (reset == 'reset') {
                    window.clearInterval(timer)
                    this.studyTime = 0
                }
            },
            //开启记忆时间
            timeKeep() {
                setInterval(this.startTimer, 1000);
            },
            //时间记录器
            startTimer() {
                this.timeVal.seconds += 1;
                this.secondNum += 1
                if (this.timeVal.seconds >= 60) {
                    this.timeVal.seconds = 0;
                    this.timeVal.minutes = this.timeVal.minutes + 1;
                }
                if (this.timeVal.minutes >= 60) {
                    this.timeVal.minutes = 0;
                    this.timeVal.hour = this.timeVal.hour + 1;
                    this.recordIntervalTime('reset')
                }
                this.timeNum = (this.timeVal.minutes < 10 ? '0' + this.timeVal.minutes : this.timeVal.minutes) + ':' + (this.timeVal.seconds < 10 ? '0' + this.timeVal.seconds : this.timeVal.seconds);
            }
        },
        watch: {},
        mounted() {
            this.getGrammarData()
            let val = Lockr.get('voiceOption')
            this.isCountdown = val.is_countdown
        }
    }
</script>

<style scoped lang='less'>
.study-wrap {
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    .left-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 10px 0 20px;
        height: 50px;
        color: #333;

        > div:nth-of-type(1) {
            display: flex;
            align-items: center;

            p {
                font-size: 18px;
            }

            img {
                display: block;
                width: 24px;
                height: 24px;
                margin-right: 10px;
            }
        }

        .countDown {
            background: url('../../../../assets/img/grammarTest/time_bg.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            width: 50px;
            height: 50px;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .content-box {
        transition: all .5s;
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .hint-text {
            flex: 1;
            position: relative;
            text-align: center;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .hint-box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 600px;
                height: 200px;
                box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);
            }

            > div:nth-of-type(2) {
                color: #ff626f;
                margin: 5px 0;
            }
        }

        .exercise-box {
            padding: 0 15px 15px 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;

            .word {
                display: flex;
            }

            .statement-text {
                font-size: 36px;
                font-weight: 600;
                padding-right: 40px;
                color: #ff6601;
                
                span {
                    margin-right: 10px;
                }

                .volume {
                    cursor: pointer;
                    /*display: block;*/
                    width: 26px;
                    height: 26px;
                    object-fit: contain;
                    margin: 0 10px;
                    vertical-align: middle;
                }

                .volume:hover {
                    opacity: 0.8;
                }
            }

            .amerism {
                font-size: 24px;

                > div:nth-of-type(1) {
                    color: #333;
                }
            }

            .tooltip {
                width: 100%;
                flex: 1;
                background: #ffffff;
                box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);
                border: 1px solid rgba(223, 223, 223, 1);
                margin: 0 auto;
                margin-top: 10px;
                display: flex;
                align-items: center;
                justify-content: center;

                .symbol {
                    font-size: 45px;
                }

                .answer {
                    font-size: 30px;
                    margin: 0 20px;
                    color: #000;
                }
            }
        }

        .control-box {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 30px;

            > div {
                margin: 0 20px;
                cursor: pointer;

                img {
                    width: 50px;
                    height: 50px;
                }
            }

            > div:hover {
                opacity: 0.7;
            }
        }
    }

    .text-right {
        text-align: right;
    }
    .el-message-box__btns {
        font-size: 16px;
        color: #333;
    }
}
</style>